var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('jds-monitor-provider',{attrs:{"console":_vm.console}},[_c('JdsTextProvider',{attrs:{"lookup":_vm.$t}},[_c('JdsTeleportProvider',[_c('JdiMenu'),_c('div',{staticClass:"lg:jds-ml-64"},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }